import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, ListGroup } from 'react-bootstrap';
import { CreditCard, ShieldCheck, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Checkout = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const applicationAmount = 200.00;

  const handlePhonePePayment = async () => {
    setLoading(true);
    navigate("/application/payment-status");
    /*try {
      // 1. Call your backend server to initiate the PhonePe transaction
      const response = await fetch('https://api.idntica.com/api/payments/phonepe/initiate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: applicationAmount,
          userId: "user_12345", // Dynamic ID from your Auth state
          applicationId: "app_98765" 
        }),
      });

      const data = await response.json();

      if (data.success && data.redirectUrl) {
        // 2. Redirect the user to PhonePe's secure hosting payment gateway
        window.location.href = data.redirectUrl;
      } else {
        alert('Payment initialization failed. Please try again.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error initiating PhonePe payment:', error);
      alert('Server error. Please try again later.');
      setLoading(false);
    }*/
  };

  return (
    <Container className="py-5" style={{ minHeight: '80vh' }}>
      <Row className="justify-content-center align-items-center h-100 mt-4">
        <Col md={6} lg={5}>
          <Card className="border-0 shadow-soft p-4 rounded-4">
            <Card.Body>
              {/* Header */}
              <div className="text-center mb-4">
                <div className="bg-light p-3 rounded-circle d-inline-block text-primary mb-2">
                  <CreditCard size={32} />
                </div>
                <h3 className="fw-bold text-dark">Application Payment</h3>
                <p className="text-muted small">Secure processing via PhonePe</p>
              </div>

              {/* Amount Breakdown */}
              <ListGroup variant="flush" className="mb-4 bg-light rounded-3 p-2">
                <ListGroup.Item className="bg-transparent d-flex justify-content-between border-0 text-muted">
                  <span>Idntica Processing Fee</span>
                  <span>₹200.00</span>
                </ListGroup.Item>
                <ListGroup.Item className="bg-transparent d-flex justify-content-between border-0 text-muted">
                  <span>Taxes & GST</span>
                  <span>₹0.00</span>
                </ListGroup.Item>
                <hr className="my-2 border-secondary" />
                <ListGroup.Item className="bg-transparent d-flex justify-content-between border-0 fw-bold text-dark fs-5">
                  <span>Total Amount</span>
                  <span className="text-primary">₹200.00</span>
                </ListGroup.Item>
              </ListGroup>

              {/* Payment Gateway Button */}
              <Button 
                variant="primary" 
                size="lg" 
                className="w-100 d-flex align-items-center justify-content-center gap-2 py-3 mb-3"
                onClick={handlePhonePePayment}
                disabled={loading}
              >
                {loading ? (
                  <span>Processing...</span>
                ) : (
                  <>
                    Pay via PhonePe <ArrowRight size={18} />
                  </>
                )}
              </Button>

              {/* Trust Badge */}
              <div className="d-flex align-items-center justify-content-center gap-2 text-muted small">
                <ShieldCheck size={16} className="text-success" />
                <span>PCI-DSS Compliant 256-bit Encryption</span>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Checkout;